/** Framed surface shared by onboarding forms, filters and empty states. */
export const onboardingPanelClassName =
  'rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm';

/** Same frame without inner padding, for divide-y lists. */
export const onboardingTableFrameClassName =
  'overflow-x-auto rounded-xl border border-border bg-card text-card-foreground shadow-sm';
